import Msg from './msg/msg.vue'
import Question from './question/question.vue'
import AppStore from '../../store/AppStore.js'
import gameData from '../../data/game.json'
import _ from 'lodash'

function delayPromise (delay = 1400) {
  return new Promise((resolve, reject) => {
    _.delay(resolve, delay)
  })
}

export default {
  components: {
    Msg, Question
  },
  data () {
    return {
      state: AppStore.state,
      scores: [0],
      currentScore: 0,
      items: [],
      itemsPopup: [],
      question: null,
      initialSlide: 0,
      rotate: false,
      fakeBadge: [
        '🌴',
        '🗺',
        '🗝',
        '🔎',
        '💎'
      ]
    }
  },
  async created () {
    // per il debug
    this.read(window.location.search ? _.parseInt(window.location.search.replace('?id=', '')) : 1)
  },
  mounted () {
    window.addEventListener('resize', this.resize)
    this.resize()
  },
  destroy () {
    window.removeEventListener('resize', this.resize)
  },
  computed: {
    itemsComputed () {
      if (this.state.popup) {
        this.items = []
        return this.itemsPopup
      } else {
        this.itemsPopup = []
        return this.items
      }
    }
  },
  methods: {
    resize () {
      var gameHeight = (this.$el.scrollHeight - 53) + 'px'
      this.$el.getElementsByClassName('game-hold')[0].style.height = gameHeight
    },
    async read (id, initialSlide) {
      var current = _.find(gameData, {id: id})
      this.initialSlide = initialSlide || 0
      AppStore.setPopup(current.type === 'popup')
      await this.showMsgs(current.msgs)
      if (current.question) {
        this.question = _.extend({}, current.question)
      }
      if (current.goto) {
        this.read(current.goto, current.initialSlide)
      }
      if (current.gotoPage) {
        AppStore.setResult(current.result)
        this.$emit('changePage', current.gotoPage)
      }
    },
    showMsgs (msgs) {
      return _.reduce(msgs, async (promise, item) => {
        await promise
        item.text = _.template(item.text)(this.state)
        this.insertItem({
          msg: item
        })
        return delayPromise(item.text ? 1400 : 2800)
      }, delayPromise())
    },
    insertItem (item) {
      this.itemsComputed.push(item)
      this.itemsLoaded()
    },
    itemsLoaded () {
      var gamePanelWrapper = this.$el.getElementsByClassName('game__panel__wrapper')
      var gamePanel = this.$el.getElementsByClassName('game__panel')
      this.$nextTick(() => {
        var customScrollH = gamePanel[0].scrollHeight
        gamePanelWrapper[0].scrollTo(0, customScrollH)
      })
    },
    enter () {
      this.rotate = true
    },
    leave () {
      setTimeout(() => {
        this.rotate = false
      }, 1000)
    },
    goto (obj, value, response) {
      this.question = null
      this.insertItem({
        msg: {
          text: response,
          human: true
        }
      })
      if (obj.name) {
        this.$set(this.state, obj.name, _.toUpper(_.head(value)) + '.')
      }
      if (obj.badge) {
        AppStore.addBadge(obj.badge)
      }
      if (obj.goto) {
        this.addScore(obj.score)
        this.read(obj.goto, obj.initialSlide)
      }
      if (obj.gotoPage) {
        AppStore.setResult(obj.result)
        this.$emit('changePage', obj.gotoPage)
      }
    },
    async addScore (score) {
      // messo array scores per attivare il transition group
      var scoreTot = AppStore.addScore(score)
      if (scoreTot !== this.scores[0]) {
        this.currentScore = score
        this.scores.shift()
        await delayPromise()
        this.currentScore = 0
        this.scores.push(scoreTot)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/component/game/game.js